import { $ } from '../../platform/dom';
import { UIPREF, applyUIPrefs, saveUIPrefs } from '../../platform/ui-prefs';
import { initQualityUI } from '../quality-ui';
import { registerScreen } from './router';
/* ============================================================
   設定畫面（2026-08-05）
   ============================================================

   在這之前畫質與音量直接擺在標題頁上，而且**開局之後就改不到了**。
   現在是獨立畫面，標題頁與（批 3 之後）暫停面板都開得了。

   三節的分法照玩家找東西的順序：畫面 → 音效 → 操作。
   「操作」目前只列鍵位（唯讀）—— 改鍵要處理衝突偵測與存檔遷移，
   那是另一個需求，放假的「自訂」按鈕比不放更糟。

   畫質與音量沿用 `ui/quality-ui.ts`（它認 `#qRow` `#qHint` `#vRow` 三個 id），
   這裡只負責把那三個容器放進設定頁、外加三個新開關。 */

var KEYS: [string, string][] = [
  ['WASD', '移動（下半身獨立轉向）'],
  ['滑鼠', '瞄準（上半身）'],
  ['SPACE', '衝刺 · 有無敵幀 · 吃推進能量'],
  ['SPACE 長按', '起飛 · 推進能量過 40% 才飛得起來（與衝刺共用）'],
  ['TAB', '鎖定目標 · 長按鎖 BOSS'],
  ['J / 左鍵', '副武裝'],
  ['K / 右鍵', '大招'],
  ['1–5', '選卡快選'],
  ['R', '選卡重抽'],
  ['P', '暫停'],
  ['C', '圖鑑'],
  ['M', '靜音'],
];

/** 一條滑桿。`fmt` 把值轉成右邊顯示的字。 */
function slider(id: string, label: string, min: number, max: number, step: number,
  val: number, fmt: (v: number) => string) {
  return '<label class="setRow"><span class="setLbl">' + label + '</span>' +
    '<input type="range" id="' + id + '" min="' + min + '" max="' + max + '" step="' + step +
    '" value="' + val + '"><i id="' + id + 'V">' + fmt(val) + '</i></label>';
}

function toggle(id: string, label: string, on: boolean, hint: string) {
  return '<label class="setRow"><span class="setLbl">' + label + '</span>' +
    '<button class="btn small tgl' + (on ? ' on' : '') + '" id="' + id + '">' +
    (on ? '開' : '關') + '</button><i class="setHint">' + hint + '</i></label>';
}

var built = false;

export function initSettings() {
  var body = $('setBody');
  if (!body || built) return;
  built = true;
  body.innerHTML =
    '<section class="setSec"><h2>畫面</h2>' +
    '<label class="setRow"><span class="setLbl">畫質</span><span id="qRow"></span>' +
    '<i class="setHint" id="qHint"></i></label>' +
    slider('setScale', '介面縮放', 0.8, 1.6, 0.05, UIPREF.scale, function (v) { return Math.round(v * 100) + '%'; }) +
    slider('setShake', '畫面震動', 0, 1.5, 0.05, UIPREF.shake, function (v) { return Math.round(v * 100) + '%'; }) +
    toggle('setDmg', '傷害數字', UIPREF.dmgNum, '關掉之後仍會顯示治療與提示') +
    '</section>' +
    '<section class="setSec"><h2>音效</h2>' +
    '<label class="setRow"><span class="setLbl">音量</span><span id="vRow"></span></label>' +
    '</section>' +
    '<section class="setSec keysSec"><h2>操作</h2><div class="keys">' +
    KEYS.map(function (k) { return '<div><kbd>' + k[0] + '</kbd><span>' + k[1] + '</span></div>'; }).join('') +
    '</div></section>';

  /* 畫質與音量的 DOM 由既有模組產生 —— 兩份實作遲早漂移，
     而它們的存檔格式與訂閱機制都已經在那邊了。 */
  initQualityUI();

  bindSlider('setScale', function (v) {
    UIPREF.scale = v; applyUIPrefs(); saveUIPrefs();
    return Math.round(v * 100) + '%';
  });
  bindSlider('setShake', function (v) {
    UIPREF.shake = v; saveUIPrefs();
    return Math.round(v * 100) + '%';
  });
  var dg: any = $('setDmg');
  if (dg) dg.addEventListener('click', function () {
    UIPREF.dmgNum = !UIPREF.dmgNum; saveUIPrefs();
    dg.textContent = UIPREF.dmgNum ? '開' : '關';
    dg.classList.toggle('on', UIPREF.dmgNum);
  });

  /* 右下角的「返回」比照機庫與圖鑑的底列（使用者 2026-08-05）——
     Esc 是給熟手的，滑鼠玩家需要一個看得到的出口。 */
  var bk = $('btnSetBack');
  if (bk) bk.addEventListener('click', closeSettings);

  registerScreen({ id: 'screenSettings', onEsc: closeSettings });
}

function bindSlider(id: string, on: (v: number) => string) {
  var el: any = $(id), num: any = $(id + 'V');
  if (!el) return;
  el.addEventListener('input', function () {
    var txt = on(parseFloat(el.value));
    if (num) num.textContent = txt;
  });
}

/** 從哪個畫面進來的 —— Esc 要回得去。 */
var from = 'screenStart';

export function openSettings(origin?: string) {
  initSettings();
  from = origin || 'screenStart';
  var f: any = $(from); if (f) f.classList.remove('show');
  var el: any = $('screenSettings'); if (el) el.classList.add('show');
}

export function closeSettings() {
  var el: any = $('screenSettings'); if (el) el.classList.remove('show');
  var f: any = $(from); if (f) f.classList.add('show');
}
